import System from "../../helper/system";
import Constants from "../../helper/Constants";


export default function exportProductListingData(t) {
  const {siteUser} = Constants
  const export_keys = {
    'ERPMFRPartNumber': t('partNumber'),
    'ManufacturerName': t('manufacturer'),
    'Availability': t('stockAvailability'),
    'LeadtimeDays': t('leadTime'),
    'Quantity': t('quantity'),
    'Min': "Min",
    'Mult': "Mult",
    'Currency': t('currency'),
    'DatasheetUrl': t('datasheet'), // DatasheetUrl is mapping from the product data
    'productDescription': t('productDescription'),
  }
  export_keys.CustomerPartNumbers = System.avUserInfoData.currentUser === siteUser.CORE ? t('customerPartNumber') : undefined;
  return export_keys;
};

export function functionDataOrder(t) {
  const {siteUser} = Constants

  return [t('partNumber'),]
    .concat((System.avUserInfoData.currentUser === siteUser.CORE ? [t('customerPartNumber')] : []))
    .concat(
      [ t('manufacturer'),
        t('stockAvailability'),
        t('leadTime'),
        t('quantity'),
        'Min',
        'Mult',
        t('currency'),
        t('datasheet'),
        t('productDescription'),
      ]);
}